import gql from 'graphql-tag'

export default gql`
mutation RunScheduleTask($taskType: ScheduleTaskType!, $runScheduleTaskId: ID!) {
  cashAssist {
    runScheduleTask(taskType: $taskType, id: $runScheduleTaskId)
  }
}`
